var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2.84473L0.0753204 27.2687L0 27.3447L24.424 51.7687L24.5 51.844L48.9247 27.4207L49 27.3447L24.576 2.92074L24.5 2.84473ZM24.5 51.5407L0.303374 27.3447L24.5 3.1488L48.6966 27.3447L24.5 51.5407Z",
    fill: "#2B292A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0L0.0753204 24.424L0 24.4993L24.424 48.9233L24.5 48.9993L48.9247 24.576L49 24.5L24.576 0.0760174L24.5 0ZM24.5 48.6959L0.303374 24.4993L24.5 0.303374L48.6966 24.4993L24.5 48.6959Z",
    fill: "#2B292A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9817 21.9692C10.5039 21.9692 10.096 22.138 9.75771 22.4749C9.41877 22.8117 9.25 23.2211 9.25 23.7023V27.6517C9.25 28.1295 9.41808 28.536 9.75562 28.8729C10.0925 29.2097 10.5012 29.3785 10.9824 29.3785C11.4559 29.3785 11.8618 29.2111 12.2007 28.8757C12.539 28.5409 12.7085 28.1329 12.7085 27.6517V26.6419H11.5773V27.6406C11.5773 27.8135 11.5152 27.9607 11.3924 28.082C11.2697 28.2034 11.1205 28.2641 10.9482 28.2641C10.7745 28.2641 10.6274 28.2034 10.5067 28.082C10.3854 27.9607 10.324 27.8135 10.324 27.6406V23.6793C10.324 23.5056 10.3854 23.3578 10.5067 23.2343C10.6274 23.1109 10.7745 23.0495 10.9482 23.0495C11.1212 23.0495 11.2697 23.1116 11.3924 23.2343C11.5159 23.3578 11.5773 23.5056 11.5773 23.6793V24.528H12.7085V23.7023C12.7085 23.2246 12.5411 22.8166 12.207 22.4776C11.8709 22.1387 11.4629 21.9692 10.9817 21.9692Z",
    fill: "#2B292A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.038 24.8277V23.7774C17.038 23.2537 16.9131 22.8457 16.6621 22.5535C16.3775 22.2187 15.9312 22.0507 15.323 22.0507H13.6025V29.2856H14.694V26.5601H15.323C15.3579 26.5601 15.39 26.5601 15.4214 26.5601L16.0825 29.2856H17.2625L16.4542 26.1277C16.8427 25.7727 17.038 25.3396 17.038 24.8277ZM15.9751 24.8508C15.9751 25.0237 15.9145 25.1723 15.7931 25.2957C15.6725 25.4191 15.5253 25.4805 15.3516 25.4805H14.6933V23.1651H15.3516C15.7673 23.1651 15.9751 23.3743 15.9751 23.7942V24.8508Z",
    fill: "#2B292A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1982 29.2857H21.3059V28.1886H19.2897V26.2136H20.7626V25.1166H19.2897V23.1415H21.3059V22.0452H18.1982V29.2857Z",
    fill: "#2B292A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2849 22.05L22.0547 29.285H23.1915L23.4565 27.6224H24.5954L24.8506 29.285H25.9978L24.7857 22.05H23.2849ZM23.6259 26.5595L24.0298 23.7071L24.4336 26.5595H23.6259Z",
    fill: "#2B292A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8975 23.1471H27.0579V29.2857H28.1494V23.1471H29.3036V22.05H25.8975V23.1471Z",
    fill: "#2B292A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2721 22.05H30.1807V29.285H31.2721V22.05Z",
    fill: "#2B292A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2363 27.6908L33.3276 22.0502H32.1846L33.4776 29.2858H34.9784L36.2958 22.0502H35.1507L34.2363 27.6908Z",
    fill: "#2B292A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.207 29.2857H40.3133V28.1886H38.2985V26.2136H39.7714V25.1166H38.2985V23.1415H40.3133V22.0452H37.207V29.2857Z",
    fill: "#2B292A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5576 17.1793H19.7042V17.136L17.5576 17.1151V17.1793Z",
    fill: "#2B292A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5977 10.295L23.8745 12.4242L23.9624 12.413L23.7253 10.2797C23.6827 10.2845 23.6402 10.2894 23.5977 10.295Z",
    fill: "#2B292A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9766 10.7106L22.7584 12.7101L22.8414 12.678L22.0958 10.6653C22.0561 10.6799 22.0156 10.6953 21.9766 10.7106Z",
    fill: "#2B292A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.502 11.5038L21.7392 13.2578L21.8131 13.2069L20.6073 11.4313C20.5717 11.4543 20.5361 11.4787 20.502 11.5038Z",
    fill: "#2B292A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7432 15.5821L19.8326 16.0717L19.8535 15.9873L17.7739 15.4545C17.7634 15.497 17.7529 15.5396 17.7432 15.5821Z",
    fill: "#2B292A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3203 14.0103L20.2305 14.9902L20.2717 14.9121L18.381 13.8953C18.3608 13.9329 18.3405 13.9713 18.3203 14.0103Z",
    fill: "#2B292A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2607 12.6238L20.8801 14.0333L20.9394 13.9663L19.3458 12.5276C19.3179 12.5597 19.29 12.5911 19.2607 12.6238Z",
    fill: "#2B292A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1562 12.6769L26.2399 12.7083L27.0182 10.7081C26.9778 10.6921 26.9367 10.6768 26.8969 10.6621L26.1562 12.6769Z",
    fill: "#2B292A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0303 12.4124L25.1181 12.4236L25.3929 10.2944C25.3504 10.2888 25.3078 10.2839 25.2646 10.2791L25.0303 12.4124Z",
    fill: "#2B292A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1436 15.9802L29.1645 16.0674L31.2539 15.5722C31.2442 15.5304 31.2337 15.4892 31.2232 15.4474L29.1436 15.9802Z",
    fill: "#2B292A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6132 13.8868L28.7246 14.9078L28.7651 14.9853L30.6739 14.0019C30.6536 13.9636 30.6334 13.9252 30.6132 13.8868Z",
    fill: "#2B292A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6467 12.5221L28.0566 13.9629L28.1145 14.0285L29.7332 12.619C29.7053 12.587 29.676 12.5542 29.6467 12.5221Z",
    fill: "#2B292A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3845 11.425L27.1836 13.2041L27.2561 13.2544L28.4926 11.499C28.4564 11.4746 28.4215 11.4502 28.3845 11.425Z",
    fill: "#2B292A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2939 17.136L29.2946 17.1793H31.4413L31.4399 17.1151L29.2939 17.136Z",
    fill: "#2B292A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8005 19.422H10.5303V19.7226H38.8005V19.422Z",
    fill: "#2B292A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8005 31.7992H10.5303V32.0991H38.8005V31.7992Z",
    fill: "#2B292A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4408 35.8128L21.0468 35.0135L20.652 35.8128L19.7705 35.9404L20.4086 36.5632L20.258 37.4412L21.0468 37.027L21.8355 37.4412L21.6856 36.5632L22.3237 35.9404L21.4408 35.8128Z",
    fill: "#2B292A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.002 35.8127L24.6073 35.0134L24.2133 35.8127L23.3311 35.9403L23.9692 36.5631L23.8185 37.4411L24.6073 37.0268L25.3961 37.4411L25.2461 36.5631L25.8843 35.9403L25.002 35.8127Z",
    fill: "#2B292A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3448 35.8129L27.9501 35.0137L27.5554 35.8129L26.6738 35.9405L27.312 36.5633L27.162 37.4414L27.9501 37.0271L28.7389 37.4414L28.5889 36.5633L29.227 35.9405L28.3448 35.8129Z",
    fill: "#2B292A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreative);
export default __webpack_public_path__ + "static/media/creative.c44ba7252e91298c4f3975d4159fb666.svg";
export { ForwardRef as ReactComponent };